import React from "react";
import ChangePageTitle from "../components/change-title-page";
import { NavLink } from "react-router-dom";

function Page404() {

    return (
        <>
            <ChangePageTitle pageTitle={`صفحه مورد نظر یافت نشد| رستوران باغبان`} />
            <div className="page404 d-flex flex-column align-items-center justify-content-center text-white" style={{ minHeight: '80vh', background: '#262626' }}>
                <h1 style={{ fontSize: '8rem', fontWeight: 'bold' }}>404</h1>
                <h2 className="text-center">صفحه ای که به دنبال آن بودید یافت نشد!</h2>
                <NavLink to="/" className="btn mt-4 px-5 text-white" style={{background:'#ed1c24'}}>
                    صفحه اصلی
                </NavLink>
            </div>
        </>
    );

}

export default Page404;